export default "__VITE_ASSET__HHXev8HZ__"